var _path, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagnostic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#5A68E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.084 11.6667H18.9173",
    stroke: "#5A68E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.834 20H20.1673",
    stroke: "#5A68E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0835 11.6666V16.6666L22.396 21.9745C22.8385 22.519 22.451 23.3333 21.7493 23.3333H10.2509C9.54923 23.3333 9.16168 22.519 9.60417 21.9745L13.9169 16.6666V11.6666",
    stroke: "#5A68E7",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.2507,
    cy: 9.58342,
    rx: 0.416666,
    ry: 0.416667,
    fill: "#5A68E7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.7507,
    cy: 7.91667,
    rx: 0.416668,
    ry: 0.416667,
    fill: "#5A68E7"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.1673,
    cy: 10.0001,
    rx: 0.833334,
    ry: 0.833333,
    fill: "#5A68E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnostic);
export default __webpack_public_path__ + "static/media/diagnostic.b23182af3016be2f6aaa154fd38db67a.svg";
export { ForwardRef as ReactComponent };